module.exports = __webpack_public_path__ + "static/media/serge-goncalves-da-silva.adcc89c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/serge-goncalves-da-silva.jpg
// module id = 1831
// module chunks = 0